import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/declare',  //首页
      name: 'declare',
      component: () => import('@/views/declare'),
      children: [{
        path: '/CustomerManagement',  // 客户管理
        name: '客户管理',
        icon:'../../../assets/u55.png',
        component: () => import('@/views/CustomerManagement'),
        children: [
          {
            path: '/CustomerManagement/CustomerInformation',  // 客户资料
            name: '客户资料',
            component: () => import('@/views/CustomerInformation'),
          },
          {
            path: '/CustomerManagement/electricityInformation',  // 客户资料
            name: '用电信息',
            component: () => import('@/views/electricityInformation'),
          },
          {
            path: '/CustomerManagement/TariffInformation',  // 客户资料
            name: '电价信息',
            component: () => import('@/views/TariffInformation'),
          },
          {
            path: '/CustomerManagement/VoltageInformation',  // 客户资料
            name: '电压信息',
            component: () => import('@/views/VoltageInformation'),
          },
          {
            path: '/CustomerManagement/ElectricityBill',  // 客户资料
            name: '电费账单',
            component: () => import('@/views/ElectricityBill'),
          },
          {
            path: '/CustomerManagement/hhxx',  // 客户资料
            name: '户号信息',
            component: () => import('@/views/hhxx'),
          },
          {
            path: '/CustomerManagement/khzlxg',  // 客户资料
            name: '修改客户资料',
            component: () => import('@/views/khzlxg'),
          },
          {
            path: '/CustomerManagement/khzlxz',  // 客户资料
            name: '新增客户资料',
            component: () => import('@/views/khzlxz'),
          },
          {
            path: '/CustomerManagement/ydxxxg',  // 客户资料
            name: '新增用电信息',
            component: () => import('@/views/ydxxxg'),
          },
          {
            path: '/CustomerManagement/dyxxxg',  // 客户资料
            name: '新增电压信息',
            component: () => import('@/views/dyxxxg'),
          },
          {
            path: '/CustomerManagement/xzdjxx',  // 客户资料
            name: '新增电价信息',
            component: () => import('@/views/xzdjxx'),
          },
          { path: '/CustomerManagement', redirect: '/CustomerManagement/CustomerInformation'},
        ]
      },
      {
        path: '/khgl',  // 客户管理
        name: '客户管理',
        component: () => import('@/views/khgl'),
      },
      {
        path: '/agent',  // 代理商档案管理
        name: '代理商档案管理',
        component: () => import('@/views/agent'),
      },
      {
        path: '/agent/detail',  // 代理商档案管理
        name: '查看代理商档案',
        component: () => import('@/views/agentdetail'),
      },
      {
        path: '/agent/update',  // 修改代理商档案
        name: '修改代理商档案',
        component: () => import('@/views/agent/update'),
      },
      {
        path: '/htgl',  // 客户管理修改信息
        name: '合同管理',
        component: () => import('@/views/htgl'),
        children: [
          {
            path: '/htgl/ckht',  // 客户资料
            name: '查看合同',
            component: () => import('@/views/ckht'),
          },
          {
            path: '/htgl/htdl',  // 客户资料
            name: '合同电量',
            component: () => import('@/views/htdl'),
          },
             {
            path: '/htgl/htwj',  // 客户资料
            name: '合同文件',
            component: () => import('@/views/htwj'),
          },
          {
            path: '/htgl/htbj',  // 客户资料
            name: '编辑合同',
            component: () => import('@/views/htbj'),
          },
          {
            path: '/htgl/htxz',  // 客户资料
            name: '新增合同',
            component: () => import('@/views/htxz'),
          },
        ]
      },
      {
        path: '/sdht',  // 客户管理修改信息
        name: '售电合同',
        component: () => import('@/views/sdht'),
      },
      {
        path: '/jyzx',  // 客户管理修改信息
        name: '交易中心',
        component: () => import('@/views/jyzx'),
        children: [
          {
            path: '/jyzx/khjsgl',  // 客户资料
            name: '查看合同',
            component: () => import('@/views/khjsgl'),
          },
          {
            path: '/jyzx/dlsjsgl',  // 客户资料
            name: '合同电量',
            component: () => import('@/views/dlsjsgl'),
          },
          {
            path: '/jyzx/khdljyjs',  // 客户资料
            name: '合同文件',
            component: () => import('@/views/khdljyjs'),
          },
             {
            path: '/jyzx/khdlsbjs',  // 客户资料
            name: '合同文件',
            component: () => import('@/views/khdlsbjs'),
          },
          {
            path: '/jyzx/khdlsbjsxg',  // 客户资料
            name: '合同文件',
            component: () => import('@/views/khdlsbjsxg'),
          },
          {
            path: '/jyzx/khdljyjsck',  // 客户资料
            name: '合同文件',
            component: () => import('@/views/khdljyjs/ck.vue'),
          },
          {
            path: '/jyzx/cksb',  // 客户资料
            name: '合同文件',
            component: () => import('@/views/cksb'),
          },
          {
            path: '/jyzx/cksbbj',  // 客户资料
            name: '合同文件',
            component: () => import('@/views/cksbbj'),
          },
          {
            path: '/jyzx/khjsglxg',  // 客户资料
            name: '新增',
            component: () => import('@/views/khjsglxg'),
          },
          {
            path: '/jyzx/khjsglck',  // 客户资料
            name: '新增',
            component: () => import('@/views/khjsgl/ck.vue'),
          },
          {
            path: '/jyzx/dlsjsglxg',  // 客户资料
            name: '新增',
            component: () => import('@/views/dlsjsglxg'),
          },
          {
            path: '/jyzx/dlsjsglck',  // 客户资料
            name: '新增',
            component: () => import('@/views/dlsjsgl/ck.vue'),
          },
          {
            path: '/jyzx/khdljyjsxg',  // 客户资料
            name: '新增',
            component: () => import('@/views/khdljyjsxg'),
          },
          {
            path: '/jyzx/khsbgl',  // 客户资料
            name: '合同文件',
            component: () => import('@/views/khsbgl'),
          },
        ]
      },
      {
        path: '/dlsgl',  // 客户管理修改信息
        name: '交易中心',
        component: () => import('@/views/dlsgl'),
        children: [
          {
            path: '/dlsgl/dlsjs',  // 客户资料
            name: '查看合同',
            component: () => import('@/views/dlsjs'),
          },
          {
            path: '/dlsgl/dlsjsxg',  // 客户资料
            name: '新增',
            component: () => import('@/views/dlsjsxg'),
          },
        ]
      },
      {
        path: '/cwgl',  // 客户管理修改信息
        name: '交易中心',
        component: () => import('@/views/cwgl'),
        children: [
          {
            path: '/cwgl/jsyj',  // 客户资料
            name: '查看合同',
            component: () => import('@/views/jsyj'),
          },
          {
            path: '/dlsgl/dlsjsxg',  // 客户资料
            name: '合同电量',
            component: () => import('@/views/dlsjsxg'),
          },
        ]
      },
      {
        path: '/xtsz',  // 客户管理修改信息
        name: '交易中心',
        component: () => import('@/views/xtsz'),
        children: [
          {
            path: '/cwgl/jsyj',  // 客户资料
            name: '查看合同',
            component: () => import('@/views/jsyj'),
          },
          {
            path: '/xtsz/zhsz',  // 客户资料
            name: '合同电量',
            component: () => import('@/views/zhsz'),
          },
        ]
      },
      {
        path: '/qxgl',  // 客户管理修改信息
        name: '合同管理',
        component: () => import('@/views/qxgl'),
        children: [
          {
            path: '/qxgl/yhlb',  // 客户资料
            name: '查看合同',
            component: () => import('@/views/yhlb'),
          },
          {
            path: '/qxgl/tjyh',  // 客户资料
            name: '合同电量',
            component: () => import('@/views/tjyh'),
          },
          {
            path: '/qxgl/xgyh',  // 客户资料
            name: '合同电量',
            component: () => import('@/views/xgyh'),
          },
             {
            path: '/qxgl/bmgl',  // 客户资料
            name: '合同文件',
            component: () => import('@/views/bmgl'),
          },
          {
            path: '/qxgl/jssq',  // 客户资料
            name: '新增合同',
            component: () => import('@/views/jssq'),
          },
          {
            path: '/qxgl/cdgl',  // 客户资料
            name: '新增合同',
            component: () => import('@/views/cdgl'),
          },
          {
            path: '/qxgl/cdgl1',  // 客户资料
            name: '新增合同',
            component: () => import('@/views/cdgl1'),
          },
        ]
      },
      {
        path: '/sy',  // 客户管理修改信息
        name: '交易中心',
        component: () => import('@/views/sy'),
        children: [
          {
            path: '/sy/xtsy',  // 客户资料
            name: '查看合同',
            component: () => import('@/views/xtsy'),
          },
        ]
      },
      {
        path: '/public',
        name: 'public',
        component: () => import('@/views/public')
      },
      {
        path: '/publicEdit',
        name: 'publicEdit',
        component: () => import('@/views/publicEdit')
      },
      {
        path: '/publicAdd',
        name: 'publicAdd',
        component: () => import('@/views/publicAdd')
      },
      {
        path: '/customerAdd',
        name: 'customerAdd',
        component: () => import('@/views/customerAdd')
      },
      {
        path: '/customerDeclare',
        name: 'customerDeclare',
        component: () => import('@/views/customerDeclare')
      },
      {
        path: '/customerDeclareAdd',
        name: 'customerDeclareAdd',
        component: () => import('@/views/customerDeclareAdd')
      },
      {
        path: '/customerDeclareEdit',
        name: 'customerDeclareEdit',
        component: () => import('@/views/customerDeclareEdit')
      },
      {
        path: '/electric',
        name: 'electric',
        component: () => import('@/views/electric')
      },
      {
        path: '/electricAdd',
        name: 'electricAdd',
        component: () => import('@/views/electricAdd')
      },
      {
        path: '/electricEdit',
        name: 'electricEdit',
        component: () => import('@/views/electricEdit')
      },
      {
        path: '/manage',
        name: 'manage',
        component: () => import('@/views/permission/manage')
      },
      {
        path: '/role',
        name: 'role',
        component: () => import('@/views/permission/role')
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('@/views/permission/user')
      },
      {
        path: '/userEdit',
        name: 'userEdit',
        component: () => import('@/views/permission/userEdit')
      },
      {
        path: '/log',
        name: 'log',
        component: () => import('@/views/log')
      }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login')
    },

  ]
})
